import { OPEN_CONFIGURATOR, OPEN_CONFIGURATOR_UNAVAILABLE } from './actions.js';
import { RECOVERABLE_ERROR, NONRECOVERABLE_ERROR, CANNOT_EXECUTE_QUERY } from './generic-query-errors.js';
import { SINGLE_PURCHASE, SUBSCRIPTION_PURCHASE, IN_STORE_SUBSCRIPTION_PURCHASE } from './purchase-types.js';

/**
 * Product Type type guards
 */ function isAccessories(product) {
    return product.productType === 'Accessories';
}
function isFrames(product) {
    return product.productType === 'Frames';
}
function isContactLens(product) {
    return product.productType === 'Contact-lenses';
}
function isSolutions(product) {
    return product.productType === 'Solutions';
}
function isSunglasses(product) {
    return product.productType === 'Sunglasses';
}
function isReadyReaders(product) {
    return product.productType === 'Ready-readers';
}
function isProductWithAFrame(product) {
    return isSunglasses(product) || isFrames(product) || isReadyReaders(product);
}
function isFramesVariant(variant) {
    return variant.variantType === 'frames';
}
function isContactLensVariant(variant) {
    return variant.variantType === 'contact-lens';
}
function isSolutionsVariant(variant) {
    return variant.variantType === 'solutions';
}
function isSinglePurchase(purchaseType) {
    return purchaseType === SINGLE_PURCHASE;
}
function isSubscriptionPurchase(purchaseType) {
    return purchaseType === SUBSCRIPTION_PURCHASE;
}
function isInStoreSubscriptionPurchase(purchaseType) {
    return purchaseType === IN_STORE_SUBSCRIPTION_PURCHASE;
}
function isRecoverableError(errorType) {
    return errorType === RECOVERABLE_ERROR;
}
function isNonRecoverableError(errorType) {
    return errorType === NONRECOVERABLE_ERROR;
}
function isNonExecutableQueryError(errorType) {
    return errorType === CANNOT_EXECUTE_QUERY;
}
function isRxProductAction(action) {
    return action === OPEN_CONFIGURATOR || action === OPEN_CONFIGURATOR_UNAVAILABLE;
}

export { isAccessories, isContactLens, isContactLensVariant, isFrames, isFramesVariant, isInStoreSubscriptionPurchase, isNonExecutableQueryError, isNonRecoverableError, isProductWithAFrame, isReadyReaders, isRecoverableError, isRxProductAction, isSinglePurchase, isSolutions, isSolutionsVariant, isSubscriptionPurchase, isSunglasses };
//# sourceMappingURL=typeguards.js.map
